
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/specials-directory",
      function () {
        return require("private-next-pages/specials-directory.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/specials-directory"])
      });
    }
  